/**
 * Action row for dialog buttons. align controls justification; layout stacks vertically on mobile, horizontal on sm+.
 * Architectural Context: Pure UI molecule. Use as Dialog.Footer.
 *
 * @param children - Buttons or other actions
 * @param align - Flex justification: left, center, or right
 * @default align 'right'
 *
 * @example
 * <Dialog.Footer align="right">
 *   <Button type="outlined" onClick={onCancel}>Cancel</Button>
 *   <Button type="contained" onClick={onConfirm}>Confirm</Button>
 * </Dialog.Footer>
 */

import React from 'react';
import { footerAlignStyles } from './Dialog.styles';

export interface DialogFooterProps {
  /** Dialog footer content */
  children: React.ReactNode;
  /** Class name for the container */
  className?: string;
  /** Controls the alignment of the footer content */
  align?: 'left' | 'center' | 'right';
}

export const DialogFooter: React.FC<DialogFooterProps> = ({
  children,
  className = '',
  align = 'right',
}) => (
  <div className={`flex flex-col-reverse sm:flex-row gap-2 sm:gap-3 mt-3 ${footerAlignStyles[align]} ${className}`}>
    {children}
  </div>
);
